import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import CentredContentContainer from "./CentredContentContainer"
import Subtitle from "./Subtitle"
import RichTextContainer from './RichTextContainer'

class LandingPageTitle extends PureComponent {
  render() {
    const {classes, className, title, subtitle, summary} = this.props;
    return (
      <CentredContentContainer className={cn(classes.titleContainer, className)}>
        <h1 className={cn(classes.noBottomMargin, classes.title)}>{title}</h1>
        {subtitle && <Subtitle className={classes.subtitle}>{subtitle}</Subtitle>}
        {summary && <RichTextContainer className={classes.summary} content={summary} />}
      </CentredContentContainer>
    )
  }
}

export default injectSheet(theme => ({
    titleContainer: {
      textAlign: "center",
      margin: '40px 0',
      [theme.breakpoint("tablet")]: {
          margin: '54px 0'
      }
    },
    title: {
      textTransform: 'initial'
    },
    summary: {
      margin: '8px auto 0 auto',
      '& p': {
        ...theme.font.subtitle,
        marginBottom: 0
      }
    },
    subtitle: {
      ...theme.font.subtitle,
      margin: '8px auto 16px auto',
    }
}))(LandingPageTitle)




// WEBPACK FOOTER //
// ./src/components/Widgets/LandingPageTitle.js